import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      padding: theme.spacing(10),
    },
  },
  center: {
    display: "flex",
    justifyContent: "center",
  },
  buttons: {
    marginTop: theme.spacing(20),
  },
  selectContent: {
    "& .MuiInputBase-root": {
      width: "100%",
    },
    overflow: "hidden",
    minHeight: theme.spacing(80),
  },
}));
